import Vue from 'vue';
import VueGtag from 'vue-gtag';
import { configs } from '../config/config.keys';

Vue.use(VueGtag, {
  config: { id: configs.gTagKey },

})